/* eslint-disable @typescript-eslint/no-unused-vars */
import { State } from '../reducers'
import { UserReferralsType } from './types'

export const getUserReferrals = (state: State): UserReferralsType => state.userReferrals
